import { Routes, Route, Navigate } from 'react-router-dom'

import UserManagementView from 'Presentation/Views/Users/List/View'
import { UserListViewContextProvider } from 'Presentation/Views/Users/List/Context'
import { UserFormModalContextProvider } from 'Presentation/Views/Users/Form/Context'

import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'

const UsersRoutes = () => (
  <Routes>
    <Route element={<ProtectedRoutePermission whitelist={RolePermissionConfigs.user} />}>
      {/* Route: User List */}
      <Route
        index
        element={
          <UserFormModalContextProvider>
            <UserListViewContextProvider>
              <UserManagementView />
            </UserListViewContextProvider>
          </UserFormModalContextProvider>
        }
      />
      {/* Route: User List */}

      <Route path='*' element={<Navigate to='/users' />} />
    </Route>
  </Routes>
)

export default UsersRoutes
